import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Nav } from "@/components/Nav";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import { fetchSiteContent } from "@/lib/api";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import About from "@/pages/About";
import Contacts from "@/pages/Contacts";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <div className="admin-scope">
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </div>
    );
  }

  return (
    <SmoothScroll>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/project/:id" element={<ProjectDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contacts" element={<Contacts />} />
      </Routes>
    </SmoothScroll>
  );
};

function App() {
  useEffect(() => {
    fetchSiteContent()
      .then((c) => {
        const hex = /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/;
        if (c?.background_color && hex.test(c.background_color)) {
          document.documentElement.style.setProperty("--vsl-bg", c.background_color);
        }
        if (c?.text_color && hex.test(c.text_color)) {
          document.documentElement.style.setProperty("--vsl-fg", c.text_color);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <AuthProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
        </LanguageProvider>
      </AuthProvider>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
